import { FC } from 'react';
import { ListProps } from './List.types';
import CardsMapper from 'components/QuickForm/CardsBucket';
import NoItemCard from 'components/QuickForm/CardsBucket/NoItemCard';
import Box from 'yoda-ui/components/Box';
import Loader from 'yoda-ui/components/Loader';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const List: FC<ListProps> = (props) => {
  const { fieldState, handleRemoveItem, list, transformToCard, disabled, loading = false } = props;
  const { shape, listConfig: { title, noItemLabel } } = list;

  return (
    <>
      <Box display="flex" marginBottom={ YodaSpacing.small }>
        { title }
        {
          loading && (
            <Box display="flex" alignItems="center" marginLeft={ YodaSpacing.xxSmall }>
              <Loader size={ 1.25 } center />
            </Box>
          )
        }
      </Box>
      <Box paddingBottom={ YodaSpacing.medium } data-testid="items-container">
        {
          fieldState && fieldState.length > 0 ? (
            fieldState.map((item) => {
              const transformedItem = transformToCard(item);
              return (
                <CardsMapper
                  key={ transformedItem.id }
                  card={ { listShape: shape, item: transformedItem } }
                  handleRemoveItem={ handleRemoveItem }
                  disabled={ disabled }
                />
              );
            })
          ) : (
            <NoItemCard noItemLabel={ noItemLabel } />
          )
        }
      </Box>
    </>
  );
};

export default List;
